import { useEffect, useState } from "react"
import { Button, Form } from "react-bootstrap"

import UpdateClubAddress from "../../components/form-inputs/UpdateClubAddressInputs"
import useAuth from "../../hooks/useAuth"
import { useUpdateClubAddressMutation } from "../../app/clubsApiSlice"
import LoadingTextSwap from "../../components/LoadingTextSwap"
import toast from "react-hot-toast"

const UpdateClubAddressForm = ({ data, setEditMode }) => {
  const [updateClubAddress, { isLoading }] = useUpdateClubAddressMutation(data.clubId)
  const [newAddress, setNewAddress] = useState(data.address)
  const [newAddressValid, setNewAddressValid] = useState(false)
  const [error, setError] = useState("")

  const isEdited = [
    newAddress.streetAddress.trim() !== data.address.streetAddress,
    newAddress.city.trim() !== data.address.city,
    newAddress.county.trim() !== data.address.county,
    newAddress.postcode.trim() !== data.address.postcode,
    newAddress.country.trim() !== data.address.country
  ].some(Boolean)

  const allFields = [
    newAddress.streetAddress,
    newAddress.city,
    newAddress.county,
    newAddress.postcode,
    newAddress.country
  ].every(Boolean)

  useEffect(() => {
    if (error) {
      if (newAddressValid && allFields) setError("")
      if (!allFields && error === "All fields must be valid") setError("All fields are required")
      if (!newAddressValid && error === "All fields are required") setError("All fields must be valid")
    }
  }, [newAddressValid, allFields])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!allFields) return setError("All fields are required")
    if (!newAddressValid) return setError("All fields must be valid")
    if (isLoading) return

    try {
      // If the address has been edited, update the club address, else do nothing but tell user update successful
      if (isEdited) await updateClubAddress({ clubId: data.clubId, address: newAddress }).unwrap()

      setEditMode(false)
      toast.success("Address updated")

    } catch (error) {
      console.log(error)
      toast.error("Failed to update club address")
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <div>
        <UpdateClubAddress address={newAddress} setAddressValid={setNewAddressValid} setNewAddress={setNewAddress} />
      </div>
      {error && <p className="text-danger i text-center fw-semibold">{error}</p>}
      <Button
        disabled={isLoading}
        className="px-5 mt-3 mx-auto rounded-3 d-block"
        variant="dark"
        type="submit"
      >
        <LoadingTextSwap isLoading={isLoading}>
          Save
        </LoadingTextSwap>
      </Button>
    </Form>
  )
}

export default UpdateClubAddressForm